/* eslint-disable @typescript-eslint/no-unused-vars */
const CaretUp = ({
  width = '19',
  height = '21',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.29683 2.05586C9.03815 1.62786 9.95151 1.62786 10.6928 2.05586L16.6285 5.48286C17.3699 5.91087 17.8266 6.70185 17.8266 7.55786V14.4119C17.8266 15.2679 17.3699 16.0589 16.6285 16.4869L10.6928 19.9139C9.95151 20.3419 9.03815 20.3419 8.29683 19.9139L2.36109 16.4869C1.61977 16.0589 1.16309 15.2679 1.16309 14.4119V7.55786C1.16309 6.70185 1.61977 5.91087 2.36109 5.48286L8.29683 2.05586Z"
        stroke="#A256BC"
        strokeWidth="1.5"
      />
      <path
        d="M12.9951 12.3182L9.49512 8.98486L5.99512 12.3182"
        stroke="#A256BC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default CaretUp;
